<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <!-- <b-col>
              <b-row>
                <b-col sm="6" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{ customerdetails.total_wallet_amount }}</h4>
            <p>Total Wallet</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="6">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{ customerdetails.ref_wallet_amount }}</h4>
            <p>Total Ref Wallet</p>
          </b-card-body>
        </b-card>
      </b-col> -->

      <!-- <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{purchase_expenses}}</h4>
            <p v-show="hide">{{ dashbd_view }}</p>
            <p>Total Purchase Expenses</p>
          </b-card-body>
        </b-card>
      </b-col>


      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i> {{purchasepayment}}</h4>
            <p>Value of Stock</p>
          </b-card-body>
        </b-card>
      </b-col> -->
    </b-row>
             </b-col>
      <div  >
          <b-row no-gutters style="">
            <b-col lg="4" >
              <b-card-body class="pb-5 text-white" style="background-color:white; font-size: 18px">
                <b-col class="pb-5 ">
                  <b-row class= "justify-content-center ">
                    <i class= "fa fa-user fa-7x mt-5" style="font-size:80px;color:black"></i>
                  </b-row>
                </b-col>
        
                  <b-row class= "mx-auto" >
                    <b-form-group>
                      <label for="name"> <b style="color:black;font-size:16px;">Customer Name: {{ customerdetails.cust_cmp_name }} </b></label>
                      <div class="small text-muted"></div>
                    </b-form-group>
                  </b-row>
             
                  <b-row class= " mx-auto" >
                    <b-form-group>
                      <label for="phone"><b style="color:black; font-size:16px;">Phone No: {{ customerdetails.cust_cmp_phone }} </b> </label>
                      <div class="small text-muted"></div>
                    </b-form-group>
                  </b-row>
               
                
                  <b-row class= "mx-auto" >
                    <b-form-group>
                      <label for="emails"> <b style="color:black; font-size:16px; ">Email ID: {{ customerdetails.cust_cmp_email }} </b>  </label>
                      <div class="small text-muted"></div>
                    </b-form-group>
                  </b-row>
                  <b-row class= "mx-auto" >
                    <b-form-group>
                      <label for="emails"> <b style="color:black; font-size:16px; ">Address: {{ customerdetails.address1 }} </b>  </label>
                      <div class="small text-muted"></div>
                    </b-form-group>
                  </b-row>
                
                
              </b-card-body>
              
            </b-col>
            <!-- <b-col lg="7" style="background-color: white; font-size: 20px">

              <--<b-card-body>
              <b-col style="font-size: 23px; " >
                <b-row class="mb-5 mt-3 justify-content-center" >
                  <b-col></b-col>
                  <b-col ><b>Personal </b></b-col>
                  <b-col></b-col>
                </b-row>
              </b-col>
              <b-col >
             
                <b-row class="mb-5 justify-content-center">
                  <b-col>
                    <b-row class="pl-4">
                      <label for="name"> <b>Address:</b>  </label>
                    </b-row>
                    <b-row class="pl-4" >{{ customerdetails.address1 }}</b-row>
                  </b-col>
                  <b-col>
                    <b-row class="justify-content-center">
                      <label for="name"> <b>Birth Date:</b></label>
                    </b-row>
                    <b-row class="justify-content-center">{{ customerdetails.birth_date }} </b-row>
                  </b-col>
                </b-row>
       
              </b-col>
              
              <b-col style="font-size: 23px; font-family: Georgia;">
                <b-row class="mb-5 mt-4 justify-content-center" >
                <hr>
                  <b-col></b-col>
                  <b-col><b>Wallet </b></b-col>
                  <b-col></b-col>
                </b-row>
              </b-col>
              <b-col >
                <b-row class="mb-5 justify-content-center">
                  <b-col>
                  <b-row class="pl-4">
                      <label for="name"> <b>Total Wallet:</b>  </label>
                    </b-row>
                    <b-row class="pl-4 ">{{ customerdetails.total_wallet_amount }}</b-row>
                  </b-col>
                  <b-col>
                  <b-row class="justify-content-center pl-2 ">
                      <label for="name"> <b>Ref Wallet:</b></label>
                    </b-row>
                    <b-row class="pr-4 justify-content-center ">{{ customerdetails.ref_wallet_amount }} </b-row>
                  </b-col>
                </b-row>
              </b-col>
              </b-card-body>
            </b-col> -->
          </b-row>
          
      </div>
    </div>
    
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
import company_mgmtVue from '../admin_pages/company_mgmt.vue';
export default {
    name: 'customergold',
  components: {
    "date-picker": DatePicker,
    Spinner,
  },  
     
  data:function() {
    return {
      customerdetails: {
            cust_cmp_name: null,
            cust_cmp_phone:null,
            address1: null,
            customer_id:null,
            birth_date:null,
            cust_cmp_email:null,
            ref_wallet_amount:null,
            total_wallet_amount:null

          },
          
          
                 
               
     
      
    }
  },
  async created(){
       await this.show_customerdetails();
      // await this.out();
      // document.body.classList.toggle('sidebar-mobile-show')
      },
    methods: {
    show_customerdetails(){
        console.log('2')
        var filteParam = {};
        var customer_id = JSON.parse(localStorage.getItem('authUserid'));
        var _this = this;
        var data=[];
        var data = data+"&filter[where][customer_id]=" +customer_id;
       console.log("/api/customercards/showcustomerdetails?params=" +
            JSON.stringify(filteParam) +
            data)
      this.$http
        .get(
          "/api/customercards/showcustomerdetails?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
            console.log('response')
            console.log(response)
          if (response.data != undefined) {
            _this.totalRecords1 = response.data.totalRecords;
            // response.data.shift();
            
              _this.customerdetails.cust_cmp_phone = response.data[0].cust_cmp_phone
              _this.customerdetails.cust_cmp_email = response.data[0].cust_cmp_email
              _this.customerdetails.cust_cmp_name = response.data[0].cust_cmp_name
              _this.customerdetails.total_wallet_amount = response.data[0].total_wallet_amount
              _this.customerdetails.ref_wallet_amount = response.data[0].ref_wallet_amount
              _this.customerdetails.address1 = response.data[0].address1
              localStorage.setItem('phone',  _this.customerdetails.cust_cmp_phone)
              var today = new Date(response.data[0].birth_date);
              var dd = today.getDate();
              var mm = today.getMonth() + 1; //January is 0!
              var yyyy = today.getFullYear();
              if (dd < 10) {
                dd = "0" + dd;
              }
              if (mm < 10) {
                mm = "0" + mm;
              }
              today = dd + "-" + mm + "-" + yyyy;
              console.log("Date:"+response.data[0].birth_date)
              _this.customerdetails.birth_date = today;
              document.body.classList.toggle('sidebar-mobile-show');
            
           
          }
        });
    },
     out() {
      //  if(window.reload()==true){
      //   var _this = this;
      //   _this.$router.push('/customerdetails');
      //  }
       
    //  window.onunload = function () {
    //   var _this = this;
    //   _this.loading = true;
    //   localStorage.clear();
    //   _this.$store.commit("SET_AUTH_USER", null);
    //   _this.$router.push('/logincustomer');
    // }
      setTimeout(() => {
      var _this = this;
      _this.loading = true;
      localStorage.clear();
      _this.$store.commit("SET_AUTH_USER", null);
      _this.$router.push("/customerlogin");
      }, 600000);
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/views/goldcustomers/customergold.vue